import React from "react";
import menuIcon from "../../assets/icons/ic-round-menu.svg";
import "../../assets/css/header.css";
import { isMobile } from "../../utils/Utils";

export default function Header( {isMobileNav, setIsMobileNav} ) {
  const userName = "Administrator";
  const userRole = "Administrator";

  let detectMobile = isMobile();

  return (
    <header
        // header_container_collapse
        className={" header_container"}
      >
        <div className="left_header"> {detectMobile && <img src={menuIcon} alt="menu-icon" onClick={() => setIsMobileNav(!isMobileNav)} />} </div>
        <div className="right_header">
          <div className="user_profile_pic">
            <span>{ userName[0] }</span>
          </div>
          <div className="user_profile_info">
            <span className="user_profile_role">{userRole}</span>
          </div>
        </div>
      </header>
  );
}
